import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { DownloadAsoListWrapper } from './download-aso-list/DownloadAsoList'

const DownloadAsoPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='download'
          element={
            <>
              <PageTitle description={t('pagina.baixarAso.descricao')}>Baixar ASOs</PageTitle>
              <DownloadAsoListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/downloadAso/download' />} />
    </Routes>
  )
}

export default DownloadAsoPage
